import { statuses, } from '@/core';
import { trip } from '@/dataStructures';

let tripStatuses = [
	statuses.trip.cancelled,
	statuses.trip.draft,
	statuses.trip.ready,
	statuses.trip.received,
	statuses.trip.started,
	statuses.trip.completed,
	statuses.trip.rejected,
];

export default {
	trip: trip(),

	tripClone: { orders: [], legs: [], deviations: [] },
	statuses: tripStatuses,
	dirty: false,
	tripLoaded: true,
	errors: {
		invalidEtd: false,
		invalidEta: false,
		invalidFromAddress: false,
		invalidToAddress: false,
		invalidVendor: false
	},
	clientSideErrors: {},
	changelog: [],
};
